import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
import { Box, Typography } from '@mui/material';
import { MinFilesValidation } from '../../../../../../../lib/validation/ValidationTypes';
const P = AntragSchema.attributes;

const Anlangen: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly, printMode } = useApplication();
	return (
		<>
			<ApplicationHeading title='Anlagen' description={PLATZHALTER_TEXT} />
			<Box>
				<Typography variant='h6' sx={{ mt: '2rem' }}>
					Erforderliche Unterlagen zum Antrag:
				</Typography>
				<ul>
					<li>Honorarvertrag/Honorarverträge für Unterrichtsstunden im Rahmen der Kooperationsprogramme</li>
					<li>Bestätigung über die Beschäftigung im Umfang von x Unterrichtsstunden im Rahmen der Kooperationsprogramme</li>
				</ul>
			</Box>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} printMode={printMode} readOnly={readOnly} />
		</>
	);
};

export default Anlangen;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			// fields: [P.Antragsunterlagen_Unterlagen],
			fields:
				[
					{
						...P.Antragsunterlagen_Unterlagen,
						minFiles: 1,
						validation: [
							{
								validateFunction: MinFilesValidation(1),
							},
						],
					}

				],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAnlangen = () => {
	return concat(formStruc());
};
